import { Fragment } from 'react'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

import { contentService } from '../../common/services/content.service'
import { useStyles } from './narrative-markdown.style'
import { Button } from '../../common/components/button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudDownload } from '@fortawesome/pro-solid-svg-icons'

export const NarrativeMarkdown = function ({ containerId, mdDocument }) {
  const classes = useStyles()

  function transformImageUri (url) {
    if (!url || url.match(/^data:/)) {
      return url
    }
    return contentService.getUrl(containerId, url)
  }

  function Image (props) {
    if (!props.src || props.src.match(/^data:/)) {
      return <img {...props} />
    }
    return (<img {...props} style={{
      maxWidth: '80%', marginLeft: 'auto', marginRight: 'auto', display: 'block'
    }} />)
  }

  function Link (props) {
    return <Fragment>
      <span className={classes.link}><Button
        variant="secondary"
        size="mini"
        title="Download results from this narrative"
        id="btn-download-results"
        onClick={() => { window.location = props.href }}
      >{props.children}<FontAwesomeIcon className={classes.linkIcon} icon={faCloudDownload} size="xs" /></Button></span>
      <span style={{ float: 'clear' }}></span>
    </Fragment>
  }

  function xformLinkUri (href, children, title) {
    if (!href.match(/^http/)) {
      href = window.getAPIBaseURL().replace(/\/$/, '') + href
    }
    return ReactMarkdown.uriTransformer(href, children, title)
  }

  return <ReactMarkdown
    className={classes.narrativeMarkdown}
    rehypePlugins={[rehypeRaw]}
    transformImageUri={ transformImageUri }
    transformLinkUri={ xformLinkUri }
    components={{
      img: Image,
      a: Link
    }}>
    { mdDocument }
  </ReactMarkdown>
}
